import { Component, ContentChildren, QueryList } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BadgeThemeEnum } from '@commons/badge/badge-theme.enum';
import { LinkComponent } from '@commons/link/link.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss'],
})
export class TabBarComponent {
  @ContentChildren(LinkComponent) links: QueryList<LinkComponent>;

  activeFragment: string;
  BadgeThemeEnum = BadgeThemeEnum;

  constructor(private readonly route: ActivatedRoute, private readonly router: Router) {
    this.route.fragment.pipe(untilDestroyed(this)).subscribe((fragment) => {
      this.activeFragment = fragment;
    });
  }

  trackByPathOrFragment(_: any, link: LinkComponent): string {
    return link.fragment ? link.fragment : link.path;
  }

  isActiveExact(path: string): boolean {
    const regex = new RegExp(`^${path}.*$`, 'i');
    return regex.test(this.router.url.split('?')[0]) && !this.router.url.includes('#');
  }
}
